
import {getUsers} from '../api/getUsers';
import {setGetUsersAction} from '../action';

const setGetUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUsers(params);

            if (data.status === 'success') {
                dispatch(setGetUsersAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetUsers
}